import {Component, Injector, Input, OnInit} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../../entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {registerSearchControl} from "../../../entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-entity-availability-single-select-search-control",
    templateUrl: "../../../entity/search/search-controls/select-search-controls/single-select-search-control.component.html",
    providers: [
        registerSearchControl(EntityAvailabilitySingleSelectSearchControlComponent)
    ]
})

export class EntityAvailabilitySingleSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> implements OnInit {
    @Input() activeName: string = "active";
    @Input() inactiveName: string = "discontinued";

    constructor(injector: Injector) {
        super(undefined, injector);
        this.initialDefaultValue = "active";
        this.allowClearSelectionOption = false;
    }

    ngOnInit(): void {
        this.buildData([
            {label: "wbo.search.option.entity-availability.all", value: "all"},
            {label: "wbo.search.option.entity-availability." + this.activeName, value: this.activeName},
            {label: "wbo.search.option.entity-availability." + this.inactiveName, value: this.inactiveName}
        ]);
    }

}
